/**
 * Crisis detection tripwire.
 * Defense-in-depth alongside system-prompt-level instructions.
 * Scans guide/assistant messages for indicators of crisis-relevant content
 * and signals when the standardized resource block should be surfaced.
 *
 * Conservative bias: false positives (showing resources unnecessarily) are
 * acceptable; false negatives are not. When in doubt, surface resources.
 */

const CRISIS_PATTERNS = [
  // Suicide / wanting to die
  /\bsuicid/i,
  /\bkill (myself|yourself|himself|herself|themself|themselves)\b/i,
  /\b(end|take) (my|your|his|her|their) (own )?life\b/i,
  /\b(don'?t want|do not want) to (live|be alive|be here|exist)\b/i,
  /\bbetter off (dead|gone|without me)\b/i,
  /\bno (reason|point) to (live|go on)\b/i,

  // Self-harm
  /\bself[- ]?harm/i,
  /\bcutting myself\b/i,
  /\bhurting myself\b/i,

  // Crisis resource references (LLM mentioning these is itself the signal)
  /\b988\b/,
  /\b741741\b/,
  /\b1[-.]?800[-.]?799[-.]?7233\b/,
  /\bcrisis (line|hotline|text line)\b/i,
  /\bsuicide (and )?crisis lifeline\b/i,

  // Abuse / domestic violence
  /\bdomestic (violence|abuse)\b/i,
  /\b(being|getting) (hit|beaten|abused)\b/i,
  /\b(physical|sexual|emotional) abuse\b/i,
];

export function detectCrisis(text) {
  if (!text || typeof text !== 'string') return false;
  return CRISIS_PATTERNS.some((pattern) => pattern.test(text));
}

export const CRISIS_RESOURCES = [
  { href: 'tel:988', display: '988', desc: 'Suicide & Crisis Lifeline (call or text)' },
  { href: 'sms:741741?body=HOME', display: 'Text HOME to 741741', desc: 'Crisis Text Line' },
  { href: 'tel:18007997233', display: '1-800-799-7233', desc: 'National Domestic Violence Hotline' },
  { href: 'tel:911', display: '911', desc: 'Emergency' },
];
